import React, { memo } from 'react';
import styles from './NonPromoMessage.module.scss';

type Props = {
  message: string;
};

const NonPromoMessage = ({ message }: Props) => {
  if (!message) {
    return null;
  }

  return (
    <p className={styles.nonpromomessage} data-test="non-promo-message">
      {message}
    </p>
  );
};

export default memo(NonPromoMessage);
